'use client';
import { useEffect, useState } from 'react';

const THEME_KEY = 'logixa_theme';
const ACCENT_KEY = 'logixa_accent';
const DEFAULT_ACCENT = '#FF652F';

export type Theme = 'dark' | 'light';

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>('dark');
  const [accent, setAccentState] = useState(DEFAULT_ACCENT);

  useEffect(() => {
    const savedTheme = (localStorage.getItem(THEME_KEY) as Theme) || 'dark';
    const savedAccent = localStorage.getItem(ACCENT_KEY) || DEFAULT_ACCENT;
    setThemeState(savedTheme);
    setAccentState(savedAccent);
    document.documentElement.setAttribute('data-theme', savedTheme);
    document.documentElement.style.setProperty('--c-accent', savedAccent);
  }, []);

  const setTheme = (t: Theme) => {
    setThemeState(t);
    localStorage.setItem(THEME_KEY, t);
    document.documentElement.setAttribute('data-theme', t);
  };

  const setAccent = (color: string) => {
    setAccentState(color);
    localStorage.setItem(ACCENT_KEY, color);
    document.documentElement.style.setProperty('--c-accent', color);
  };

  const toggle = () => setTheme(theme === 'dark' ? 'light' : 'dark');

  return { theme, setTheme, toggle, accent, setAccent };
}
